import { DeviceMicroController } from "../models/dto/web/DeviceMicroController";

export const getMicroControllerDisplayName = (controller: string): string => {
  const mapping: Record<string, string> = {
    [DeviceMicroController.COBRA_DEVICE_MC]: 'Controller MC',
    [DeviceMicroController.COBRA_DEVICE_SC]: 'Controller SC',
    [DeviceMicroController.COBRA_PL_SENSOR_MC]: 'Plattform sensor MC',
    [DeviceMicroController.COBRA_PL_SENSOR_SC]: 'Plattform sensor SC',
  };
  return mapping[controller] || controller;
};
